import { API } from "@/api/HttpConfig.js";
import { Toast } from "vant";
export default class AudioPlayer {
  constructor(callback) {
    /** 状态 */
    this.fetchDone = false; // 网络流是否结束
    this.isPlaying = false; // 是否正在播放（驼峰统一）
    this.isLoadData = false; // 是否正在拉流

    /** 中断控制 */
    this.abortController = null; // 用于取消 fetch

    /** DOM & Web‑Audio */
    this.audio = new Audio();
    this.audio.autoplay = true;
    this.audio.disableRemotePlayback = true;

    this.audioContext = new AudioContext();
    const MediaSource = window.ManagedMediaSource || window.MediaSource;
    this.mediaSource = new MediaSource();
    this.sourceBuffer = undefined;

    this.audio.src = URL.createObjectURL(this.mediaSource);
    const node = this.audioContext.createMediaElementSource(this.audio);
    node.connect(this.audioContext.destination);
    /* ---------- SourceBuffer ---------- */
    this.cacheBuffers = [];
    this.mediaSource.addEventListener("sourceopen", () => {
      if (this.sourceBuffer) return;
      this.sourceBuffer = this.mediaSource.addSourceBuffer("audio/mpeg");
      this.sourceBuffer.mode = "sequence";
      this.sourceBuffer.addEventListener(
        "updateend",
        this._flushAndMaybeEnd.bind(this)
      );
    });

    /* ---------- 回调绑定 ---------- */
    this.setCallback(callback);
  }
  setCallback(cb) {
    this.callback = cb;
    if (!cb) return;
    [
      "ended",
      "pause",
      "loadeddata",
      "play",
      "timeupdate",
      "canplay",
      "error",
    ].forEach((ev) => {
      this.audio.addEventListener(ev, () => cb(ev), false);
    });
  }
  /** 收到分片 */
  _receiveAudioData(u8) {
    if (this.isDestroyed || !this.sourceBuffer) return;
    if (!u8) return this._flushAndMaybeEnd();

    const buf = u8.buffer.slice(u8.byteOffset, u8.byteOffset + u8.byteLength);
    if (!Array.isArray(this.cacheBuffers)) this.cacheBuffers = [];

    if (this.sourceBuffer.updating || this.cacheBuffers.length)
      this.cacheBuffers.push(buf);
    else this.sourceBuffer.appendBuffer(buf);

    if (this.isPlaying) this.audio.play().catch(() => {});
  }

  /** flush & endStream 统一逻辑 */
  _flushAndMaybeEnd() {
    if (this.isDestroyed || !this.cacheBuffers) return;

    // flush
    if (this.cacheBuffers.length && !this.sourceBuffer.updating) {
      this.sourceBuffer.appendBuffer(this.cacheBuffers.shift());
      return;
    }

    // decide end
    if (
      this.fetchDone &&
      !this.cacheBuffers.length &&
      !this.sourceBuffer.updating &&
      this.mediaSource.readyState === "open"
    ) {
      try {
        this.mediaSource.endOfStream();
      } catch (_) {}
    }
  }
  // 调接口获取语音
  async loadAudio(ai_app_code, text) {
    console.log("执行loadAudio");
    this.isplaying = true;
    // 创建 AbortController，用于后续取消
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      this.callback && this.callback("loading");
      // Toast("开始获取音频流");
      const response = await fetch(API.TextToAudio, {
        method: "POST",
        headers,
        signal, // <‑‑ 关键
        body: JSON.stringify({
          bizReq: JSON.stringify({
            ai_app_code: ai_app_code,
            text: text,
          }),
          clientType: window.localStorage.getItem("clientType_AI"),
          appId: window.localStorage.getItem("appId_AI"),
          sessionId: window.localStorage.getItem("sessionId_AI"),
          timestamp: Date.parse(new Date()),
        }),
      });
      this.callback && this.callback("loadover");
      if (response.status !== 200) {
        this.isLoadData = false;
        if (this.callback) this.callback("fetch_error");
      }
      const reader = response.body.getReader();
      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          console.log("结束");
          this.fetchDone = true; // <‑‑ 网络真正结束
          // Toast("音频流获取完毕");
          this._receiveAudioData(value);
          break;
        }
        // Toast(`拿到了一段音频流${new Date().getTime()}`);
        this._receiveAudioData(value);
      }
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        // fetch 被外部取消，静默处理或回调
        this.callback && this.callback("aborted", error);
      } else {
        this.callback && this.callback("error", error);
      }
      this.isplaying = false;
      this.isLoadData = false;
    }
  }
  async autoLoadAudio(ai_app_code, conversationId, messageId) {
    this.isplaying = true;
    // 创建 AbortController，用于后续取消
    this.abortController = new AbortController();
    const { signal } = this.abortController;
    try {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      this.callback && this.callback("loading");
      // Toast("开始获取音频流");
      const response = await fetch(API.autoTextToAudio, {
        method: "POST",
        headers,
        signal, // <‑‑ 关键
        body: JSON.stringify({
          bizReq: JSON.stringify({
            ai_app_code,
            conversationId,
            messageId,
          }),
          clientType: window.localStorage.getItem("clientType_AI"),
          appId: window.localStorage.getItem("appId_AI"),
          sessionId: window.localStorage.getItem("sessionId_AI"),
          timestamp: Date.parse(new Date()),
        }),
      });
      this.callback && this.callback("loadover");
      if (response.status !== 200) {
        this.isLoadData = false;
        if (this.callback) this.callback("fetch_error");
      }
      const reader = response.body.getReader();
      while (true) {
        const { value, done } = await reader.read();
        if (done) {
          console.log("结束");
          this.fetchDone = true; // <‑‑ 网络真正结束
          // Toast("音频流获取完毕");
          this._receiveAudioData(value);
          break;
        }
        // Toast(`拿到了一段音频流${new Date().getTime()}`);
        this._receiveAudioData(value);
      }
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        // fetch 被外部取消，静默处理或回调
        this.callback && this.callback("aborted", error);
      } else {
        this.callback && this.callback("error", error);
      }
      this.isplaying = false;
      this.isLoadData = false;
    }
  }
  /** 销毁播放器实例（外部调用） */
  destroy() {
    if (this.isDestroyed) return;
    this.isDestroyed = true;

    this.abortController?.abort();

    try {
      this.audio.pause();
    } catch (_) {}
    this.audio.removeAttribute("src");
    this.audio.load();

    try {
      if (this.audioContext.state !== "closed") this.audioContext.close();
    } catch (_) {}
    try {
      if (this.mediaSource.readyState === "open")
        this.mediaSource.endOfStream();
    } catch (_) {}

    this.cacheBuffers = [];
    this.audio =
      this.audioContext =
      this.mediaSource =
      this.sourceBuffer =
        null;
    this.callback?.("destroy");
  }
}
